document.addEventListener('DOMContentLoaded', function () {
    const detailsElements = document.querySelectorAll('.header__menu_item');
  
    detailsElements.forEach(function (detailsElement) {
      let timeout;
  
      detailsElement.addEventListener('mouseenter', function () {
        clearTimeout(timeout);
        detailsElement.setAttribute('open', '');
      });
  
      detailsElement.addEventListener('mouseleave', function () {
        timeout = setTimeout(function () {
          detailsElement.removeAttribute('open');
        }, 200); 
      });
    });
  });
  